export default __webpack_public_path__ + "static/peel-d57b108cc75190625081759eaa63bfaa.png";